import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.styl']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.scrollTo(0,0);
  }

  toggleAccordion(id){
    const $infoElement = document.getElementById(`${id}`);
    const $listItems = $infoElement.parentElement.getElementsByTagName('li');
    for (let i = 0; i <= $listItems.length - 1; i++) {
      $listItems[i].classList.remove('open')
    }
    $infoElement.classList.toggle('open');
  }

}
